import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import style from './ConditionTypeSelector.module.css';

const ConditionTypeSelector = ({
  conditionsCatalog = [],
  conditionSelected = null,
  loading = false,
  onConditionTypeSelected = () => {},
  onRemoveCondition = () => {},
  removable = false,
}) => {
  const { t } = useTranslation('fileClaimbot');

  const onChange = (newCondition) => {
    onConditionTypeSelected(newCondition);
  };

  return (
    <div>
      <div className={style.row}>
        <h2 className={style.title}>{t('conditions.select.title')}</h2>

        {removable ? (
          <button
            className={style.removeButton}
            onClick={onRemoveCondition}
            type="button"
          >
            {t('conditions.remove')}
          </button>
        ) : null}
      </div>

      <Select
        blurInputOnSelect={false}
        className={style.select}
        defaultValue={conditionSelected}
        isLoading={loading}
        onChange={onChange}
        openMenuOnFocus
        options={conditionsCatalog}
        placeholder={t('conditions.select.placeholder')}
        styles={{
          container: (provided) => ({
            ...provided,
            padding: '0px',
          }),
          control: (provided) => ({
            ...provided,
            borderColor: 'var(--pc-color-onyx-200)',
            borderRadius: '8px',
            minHeight: 'auto',
            padding: '4px',
          }),
          dropdownIndicator: (provided, state) => ({
            ...provided,
            padding: '0px',
            // theres no way to know if the menu is open or not
            // so we use isFocused instead
            transform: state.isFocused ? 'rotate(180deg)' : '',
            transition: 'all .2s ease',
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            padding: '0px',
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: 'transparent',
          }),
          input: (provided) => ({
            ...provided,
            margin: '0px',
            padding: '0px',
          }),
          menuList: (provided) => ({
            ...provided,
            '::-webkit-scrollbar': {
              width: '12px',
            },
            '::-webkit-scrollbar-thumb': {
              background: 'var(--pc-color-cotton-500)',
              borderRadius: '8px',
            },
            '::-webkit-scrollbar-track': {
              background: 'var(--pc-color-cotton-200)',
            },
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
              ? 'var(--pc-color-blue-100)'
              : 'var(--white)',
            color: 'var(--pc-color-onyx-300)',
          }),
          placeholder: (provided) => ({
            ...provided,
            marginTop: '2px', // because of font family
          }),
          singleValue: (provided) => ({
            ...provided,
            marginTop: '2px', // because of font family
          }),
          valueContainer: (provided) => ({
            ...provided,
            padding: '0px',
          }),
        }}
        value={conditionSelected?.label ? conditionSelected : null}
      />

      <p className={style.disclaimer}>{t('conditions.select.disclaimer')}</p>
    </div>
  );
};

export { ConditionTypeSelector };
